const GeneralInformationButton = ({ onSelectInformation }) => {
  return (
    <div className="flex flex-col justify-center items-center h-full w-full">
      <div className="flex flex-row gap-x-2 h-full max-h-[30px] mb-2">
        <div
          className="flex flex-row justify-center items-center bg-[#A09200] rounded rounded-md text-white px-3 py-2 w-[160px] text-[10px]"
          onClick={() =>
            onSelectInformation(
              "I want to know more about National Orchid Garden",
            )
          }
        >
          National Orchid Garden
        </div>
        <div
          className="flex flex-row justify-center items-center bg-[#A09200] rounded rounded-md text-white px-3 py-2 w-[160px] text-[10px]"
          onClick={() =>
            onSelectInformation(
              "Is there a lost and found counter if I lose or find any belonging?",
            )
          }
        >
          Lost & Found
        </div>
      </div>

      <div className="flex flex-row gap-x-2 h-full max-h-[30px] mb-2">
        <div
          className="flex flex-row justify-center items-center bg-[#A09200] rounded rounded-md text-white px-3 py-2 w-[160px] text-[10px]"
          onClick={() =>
            onSelectInformation(
              "What are the visitor guidelines that i need to be aware of?",
            )
          }
        >
          Visitor Guidelines
        </div>
        <div
          className="flex flex-row justify-center items-center bg-[#A09200] rounded rounded-md text-white px-3 py-2 w-[160px] text-[10px]"
          onClick={() => onSelectInformation("Where are the toilets?")}
        >
          Toilet Access
        </div>
      </div>

      <div
        className="flex flex-row justify-center items-center bg-[#A09200] rounded rounded-md text-white px-3 py-2 w-[110px] text-[10px] gap-x-2 h-full max-h-[30px]"
        onClick={() => onSelectInformation("Where can I Shop and Dine?")}
      >
        Shop & Dine
      </div>
    </div>
  );
};
export default GeneralInformationButton;
